let breakpointVideo = window.matchMedia('(min-width: 1280px)');
const announcementHeightSection = document.querySelector('#shopify-section-announcement-banner');
const headerSection = document.querySelector('#shopify-section-header');
let headerHeight = headerSection.clientHeight;
if(announcementHeightSection || headerSection) {
  headerHeight = headerSection.clientHeight + announcementHeightSection.clientHeight;
  document.body.style.setProperty('--static-header-height', `${(headerHeight)}px`);
}

var tag = document.createElement('script');
tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
const videoPlayerWrap = document.querySelector('.js-video-with-text__player');
const YTPlayer = document.querySelector('#js-player');
const videoCovers = document.querySelectorAll('.js-video-with-text__icon-play');
const videoOverlay = document.querySelector('.video-with-text__player-overlay');
const videoWrapper = document.querySelector('.js-video-with-text__media-video');
const customVideo = document.querySelector('.js-video-with-text__player video');

var playerEl;
function onYouTubeIframeAPIReady() {
  if(YTPlayer) {
    playerEl = new YT.Player('js-player', {
      height: '100%',
      width: '100%',
      videoId: videoPlayerWrap.dataset.videoId,
      playerVars: {
        'autoplay': 1,
        'controls': 1,
        'mute': 1,
        'loop': 1,
        'rel': 0,
        'autohide': 1,
        'showinfo': 0,
        'playlist': videoPlayerWrap.dataset.videoId
      },
      events: {
        'onReady': onPlayerReady,
        'onStateChange': onPlayerStateChange
      },
    });
  }
}

function onPlayerReady() {
  listenPlayback();
  if(!breakpointVideo.matches) {
    if(videoWrapper.getBoundingClientRect().top >= 0 && videoWrapper.getBoundingClientRect().bottom <= (window.innerHeight + 150)) {
      videoCovers && videoCovers.forEach(el => {
        el.click();
      });
    }
  } else {
    let startPosition = '50% bottom';
    let endPosition = {
      end: `center ${headerHeight}`
    };
    ScrollTrigger.create({
      trigger: '.js-video-with-text__media-video',
      start: startPosition,
      ...endPosition,
      scrub: true,
      onEnter: () => {
        videoCovers && videoCovers.forEach(el => {
          el.click();
        });
      },
      onLeave: () => stopYTVideo(),
      onEnterBack: () => {
        videoCovers && videoCovers.forEach(el => {
          el.click();
        });
      },
      onLeaveBack: () => stopYTVideo()
    });
  }
}

function onPlayerStateChange(event) {

}

// function onPlayerStateChange(event) {
//   if (event.data === 1) {
//     document.querySelector('#play_pause').innerHTML = 'Pause';
//   }
//   else {
//     document.querySelector('#play_pause').innerHTML = 'Play';
//   }
// }

function listenPlayback() {
  const progress = document.querySelector('.js-video-with-text__video-progress');
  const progressBar = document.querySelector('.js-video-with-text__video-progress-bar');
  const currentTimeEl = document.querySelector('.js-video-with-text__video-current-time');
  const durationTimeEl = document.querySelector('.js-video-with-text__video-duration');
  
  if (!progress.getAttribute('max')) progress.setAttribute('max', playerEl.getDuration());
  progress.value = playerEl.getCurrentTime();
  progressBar.style.transform = `scaleX(${Math.floor((playerEl.getCurrentTime() / playerEl.getDuration()) * 100)}%)`;
  
  currentTimeEl.innerHTML = formatVideoTime(playerEl.getCurrentTime());
  durationTimeEl.innerHTML = formatVideoTime(playerEl.getDuration());
  setTimeout(listenPlayback, 300);
}

videoCovers && videoCovers.forEach(el => {
  el.addEventListener('click', (e) => {
    playYTVideo();
    playVideo();
  });
})

videoOverlay && videoOverlay.addEventListener('click', () => {
  pauseYTVideo();
  pauseVideo();
});

const videoPlayerClose = document.querySelector('.js-video-with-text__player-close-button');
if(videoPlayerClose) {
  videoPlayerClose.addEventListener('click', (e) => {
    e.preventDefault();
    stopYTVideo();
    stopVideo();
    if(!breakpointVideo.matches) {
      scrollLock(false);
    }
  });
}

function playYTVideo() {
  if(playerEl && YTPlayer) {
    playerEl.playVideo();
    videoCovers.forEach(el => {
      el.style.display = 'none';
    })
    videoOverlay && (videoOverlay.style.display = 'block');
    // if (playerEl.getPlayerState() !== 1) {
    // }
    if(!breakpointVideo.matches) {
      if(videoWrapper) {
        videoWrapper.classList.add('video-with-text__media-video--active');
      }
    }
  }
}

function pauseYTVideo() {
  if(playerEl && YTPlayer) {
    if (playerEl.getPlayerState() === 1) {
      playerEl.pauseVideo();
    } else {
      playerEl.playVideo();
    }
    // videoCovers.forEach(el => {
    //   el.style.display = 'block';
    // })
    videoCovers.forEach(el => {
      el.style.display = 'none';
    })
    videoOverlay && (videoOverlay.style.display = 'block');
  }
}

function stopYTVideo() {
  if(playerEl && YTPlayer) {
    if (playerEl.getPlayerState() === 1) {
      playerEl.stopVideo();
    }

    videoCovers.forEach(el => {
      el.style.display = 'block';
    })
    videoOverlay && (videoOverlay.style.display = 'none');

    if(!breakpointVideo.matches) {
      if(videoWrapper) {
        videoWrapper.classList.remove('video-with-text__media-video--active');
      }
    }
  }
}

function formatVideoTime(s) {
  let m = Math.floor(s / 60);
  m = (m >= 10) ? m : "0" + m;
  s = Math.floor(s % 60);
  s = (s >= 10) ? s : "0" + s;
  return m + ":" + s;
}

// document.querySelector('#sounds').addEventListener('click', () => {
// if (playerEl.isMuted()) {
//   playerEl.unMute();
//   document.querySelector('#sounds').innerHTML = 'Turn Sound Off';
// }
// else {
//   playerEl.mute();
//   document.querySelector('#sounds').innerHTML = 'Turn Sound On';
// }
// }) 

function stopVideo() {
  const progress = document.querySelector('.js-video-with-text__video-progress');

  if(customVideo) {
    customVideo.pause();
    customVideo.currentTime = 0;
    progress.value = 0;
    customVideo.autoplay = false;
    videoCovers.forEach(el => {
      el.style.display = 'block';
    })
    videoOverlay && (videoOverlay.style.display = 'none');

    if(!breakpointVideo.matches) {
      if(videoWrapper) {
        videoWrapper.classList.remove('video-with-text__media-video--active');
      }
    }
  }
}

function pauseVideo() {
  if(customVideo) {
    customVideo.muted = true;
    if(customVideo.paused) {
      customVideo.play();
    } else {
      customVideo.pause();
    }

    videoCovers.forEach(el => {
      el.style.display = 'none';
    })
    videoOverlay && (videoOverlay.style.display = 'block');
  }
}

function playVideo() {
  if(customVideo) {
    customVideo.muted = true;
    customVideo.controls = true;
    customVideo.autoplay = false;
    customVideo.playsinline = true;
    customVideo.play();

    videoCovers.forEach(el => {
      el.style.display = 'none';
    })
    videoOverlay && (videoOverlay.style.display = 'block');
    if(!breakpointVideo.matches) {
      if(videoWrapper) {
        videoWrapper.classList.add('video-with-text__media-video--active');
      }
    }
  }

  videoCovers.forEach(el => {
    el.style.display = 'none';
  })
  videoOverlay && (videoOverlay.style.display = 'block');
  // if (playerEl.getPlayerState() !== 1) {
  // }
  if(!breakpointVideo.matches) {
    if(videoWrapper) {
      videoWrapper.classList.add('video-with-text__media-video--active');
    }
  }
}

function progressBar() {
  const videoEl = document.querySelector('.js-video-with-text__player video');
  const progress = document.querySelector('.js-video-with-text__video-progress');
  const progressBar = document.querySelector('.js-video-with-text__video-progress-bar');
  const currentTimeEl = document.querySelector('.js-video-with-text__video-current-time');
  const durationTimeEl = document.querySelector('.js-video-with-text__video-duration');

  if(!progress || !videoEl) return;

  const supportsProgress = progress.max !== undefined;
  if (!supportsProgress) progress.setAttribute("data-state", "fake");
  if (document.addEventListener) {
    videoEl.addEventListener('loadedmetadata', function() {
      progress.setAttribute('max', videoEl.duration);
    });
  }

  // As the video is playing, update the progress bar
  videoEl && videoEl.addEventListener('timeupdate', function() {
    // For mobile browsers, ensure that the progress element's max attribute is set
    if (!progress.getAttribute('max')) progress.setAttribute('max', videoEl.duration);
    progress.value = videoEl.currentTime;
    progressBar.style.transform = `scaleX(${Math.floor((videoEl.currentTime / videoEl.duration) * 100)}%)`;
  
    currentTimeEl.innerHTML = formatVideoTime(videoEl.currentTime);
    durationTimeEl.innerHTML = formatVideoTime(videoEl.duration);
  });

  progress && progress.addEventListener('click', function(e) {
    if(!videoEl) return;
    videoEl.autoplay = true;
    var barPosition = (e.pageX - (this.offsetLeft + this.offsetParent.offsetLeft)) / this.offsetWidth;
    videoEl.currentTime = barPosition * videoEl.duration;
  }); 

  videoEl && videoEl.addEventListener('click', () => {
    pauseVideo();
    if (!progress.getAttribute('max')) progress.setAttribute('max', videoEl.duration);
    progress.value = videoEl.currentTime;
    progressBar.style.transform = `scaleX(${Math.floor((videoEl.currentTime / videoEl.duration) * 100)}%)`;
  })

}

function heroMediaParallaxEffect() {
  const heroMedias = document.querySelectorAll('.video-with-text');
  let triggerStart = 'bottom bottom';
  if(!breakpointVideo.matches) {
    triggerStart = 'center bottom';
    heroMedias && heroMedias.forEach((slideImage) => {
      gsap.to(slideImage.querySelectorAll(".js-video-with-text__media-video"), {
        yPercent: 35,
        ease: "none",
        scrollTrigger: {
          trigger: slideImage.querySelectorAll(".js-video-with-text__media-video"),
          start: triggerStart,
          end: "bottom top",
          scrub: true
        }
      });
    }); 
  }

  heroMedias && heroMedias.forEach((slideImage) => {
    const imageEl = slideImage.querySelectorAll(".video-with-text__media-image img, .video-with-text__image-background img");
    if(imageEl) {
      gsap.to(imageEl, {
        yPercent: 35,
        ease: "none",
        scrollTrigger: {
          trigger: slideImage.querySelectorAll(".video-with-text__media-image, .video-with-text__image-background"),
          start: triggerStart,
          end: "bottom top",
          scrub: true
        }
      });
    }
  }); 
}

progressBar();
if(customVideo) {
  if(!breakpointVideo.matches) {
    if(videoWrapper.getBoundingClientRect().top >= 0 && videoWrapper.getBoundingClientRect().bottom <= window.innerHeight) {
      videoCovers && videoCovers.forEach(el => {
        el.click();
      });
    }
  } else {
    let startPosition = '50% bottom';
    let endPosition = {
      end: `center ${headerHeight}`
    };
    
    ScrollTrigger.create({
      trigger: '.js-video-with-text__media-video',
      start: startPosition,
      ...endPosition,
      scrub: true,
      onEnter: () => {
        videoCovers && videoCovers.forEach(el => {
          el.click();
        });
      },
      onLeave: () => stopVideo(),
      onEnterBack: () => {
        videoCovers && videoCovers.forEach(el => {
          el.click();
        });
      },
      onLeaveBack: () => stopVideo()
    });
  }
}

heroMediaParallaxEffect();